import { IUser } from 'data/entities/credentials.entity';
import { credentialsRepository } from 'data/repositories/credential.repository';

export const getUser = (): IUser | null => {
    try {
        const credentials = credentialsRepository.getCredentials();
        if (!credentials) throw Error('unauthenticated');
        return credentials.user;
    } catch ({ message }) {
        console.error(message);
        return null;
    }
};
